import * as React from 'react'
// hooks
import { useModalData } from 'hooks/useShowModal'
// components
import { DrawerModal } from 'components/UI'
// view components
import ReviewResultContainer from 'containers/Review/ReviewResult'
// constants
import { Modals } from 'constants/index'

const PAPER_PROPS = {
  style: {
    top: '64px',
    left: '72px',
    height: '100%',
    width: '414px',
    overflow: 'visible',
    zIndex: 1300
  }
}

const SidebarReviewDetailsModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, entity, review }
  } = useModalData({ modalType: Modals.SIDEBAR_REVIEW_DETAILS_MODAL })

  return (
    <DrawerModal width={'100%'} anchor={'left'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <ReviewResultContainer entity={entity} hideModal={hideModal} review={review} />
    </DrawerModal>
  )
}

export default SidebarReviewDetailsModal
